import { render, staticRenderFns } from "./ComboTreeAdminRegion.vue?vue&type=template&id=015d4e81&"
import script from "./ComboTreeAdminRegion.vue?vue&type=script&lang=js&"
export * from "./ComboTreeAdminRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports